skrilla.controller('createMarketItemModalCtrl', function ($scope, searchService, modalService, currencyService, validationService) {
    var validation = validationService;
    $scope.sizes = ["SMALL", "MEDIUM", "LARGE"];
    $scope.transportTypes = ["PHYSICAL", "DIGITAL"];
    $scope.activeStates = [true, false];
    $scope.validate = {name: ""};
    $scope.item = {};

    $scope.save = function(){
        if(validateForm()) {
            const request = {...$scope.item, audPrice: currencyService.multiply($scope.item.audPrice, "AUD")}
            searchService.post("markets/items", request, "Item successfully created").then(function (response) {
                modalService.dismissAll()
            }, function(response){
                $scope.item.audPrice = currencyService.divide($scope.item.audPrice, "AUD");
            });
        }
    }

    function validateForm(){
        var item = $scope.item;
        var inputs = [
            validation.buildFieldValidationObj("name", !validation.isEmpty(item.name), "Please enter a name"),
            validation.buildFieldValidationObj("link", !validation.isEmpty(item.link) && item.link.startsWith("https://"), "Please enter a valid link (https://)"),
            validation.buildFieldValidationObj("imageUrl", !validation.isEmpty(item.imageUrl) && item.imageUrl.startsWith("https://res.cloudinary.com/skrilla/image/"), "Please enter an Image Url from Cloudinary"),
            validation.buildFieldValidationObj("audPrice", !validation.isEmpty(item.audPrice), "Please enter an AUD Price"),
            validation.buildFieldValidationObj("size", !validation.isEmpty(item.size), "Please enter a size"),
            validation.buildFieldValidationObj("transportType", !validation.isEmpty(item.transportType), "Please enter a transport type")
        ];
        return validation.validateForm(inputs, $scope.validate)
    }

});